import React, { createContext, useReducer } from "react";
import InterpreterInvoiceReportReducer from "../../reducers/reports/interpreterInvoiceReportReducer";
import axios from "../../../axios";

const initialState = {
  loading: false,
  interpreterInvoices: [],
  interpreters: [],
  clients: [],

  totalAmount: 0,
  totalVAT: 0,
  totalInvoice: 0,
  count: 0,

  error: null,
};

export const InterpreterInvoiceReportContext = createContext(initialState);

export const InterpreterInvoiceReportProvider = ({ children }) => {
  const [state, dispatch] = useReducer(
    InterpreterInvoiceReportReducer,
    initialState,
  );

  // Get Interpreter Invoice Report
  const getInterpreterInvoiceReportHandler = async (filter) => {
    try {
      const result = await axios.get(
        `/api/v1/bookings/ipinvoicereport?${filter}`,
      );

      dispatch({
        type: "FETCH_INTERPRETER_INVOICE_RECORDS",
        payload: result.data,
      });
    } catch (error) {
      console.error(error);
      dispatch({
        type: "PROCESS_ERROR",
        payload: error,
      });
    }
  };

  // Get Interpreters
  const getInterpretersHandler = async (fullname) => {
    try {
      const result = await axios.get(`/api/v1/interpreters?fname=${fullname}`);

      dispatch({
        type: "FETCH_INTERPRETER_RECORDS",
        payload: result.data,
      });
    } catch (error) {
      console.error(error);
    }
  };

  // Get Clients / Companies
  const getClientsHandler = async (company) => {
    try {
      const result = await axios.get(`/api/v1/clients?companyName=${company}`);

      dispatch({
        type: "FETCH_CLIENT_RECORD",
        payload: result.data,
      });
    } catch (error) {
      console.error(error);
    }
  };

  // Clear State
  const clearInterpreterInvoiceStateHandler = () => {
    dispatch({
      type: "PROCESS_START",
    });
  };

  return (
    <InterpreterInvoiceReportContext.Provider
      value={{
        loading: state.loading,
        interpreterInvoices: state.interpreterInvoices,
        interpreters: state.interpreters,
        clients: state.clients,

        totalAmount: state.totalAmount,
        totalVAT: state.totalVAT,
        totalInvoice: state.totalInvoice,
        count: state.count,

        error: state.error,

        getInterpreterInvoiceReportHandler,
        getInterpretersHandler,
        getClientsHandler,
        clearInterpreterInvoiceStateHandler,
      }}
    >
      {children}
    </InterpreterInvoiceReportContext.Provider>
  );
};
